import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Seo from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail?.msg || detail);
};

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("ono_admin_token", data.token);
      navigate("/admin/inquiries");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="pt-32 pb-24 min-h-screen">
      <Seo title="Admin Sign In — 1001 Nights Orchestra" siteName="1001 Nights Orchestra" />
      <div className="max-w-md mx-auto px-4">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-amber-400">Admin</p>
        <h1 className="mt-4 font-serif text-4xl text-amber-50 tracking-tight">Sign In</h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-10 border border-amber-500/15 bg-surface/60 p-8 space-y-6">
          <div>
            <label htmlFor="ad-email" className="block font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400 mb-2">Email</label>
            <input id="ad-email" type="email" data-testid="admin-email-input" className="field" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </div>
          <div>
            <label htmlFor="ad-pass" className="block font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400 mb-2">Password</label>
            <input id="ad-pass" type="password" data-testid="admin-password-input" className="field" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-300/90 border border-red-900/50 bg-red-950/30 px-4 py-3">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3.5 bg-gold text-midnight font-mono text-xs uppercase tracking-[0.2em] hover:bg-gold-bright transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
